import React, { ReactElement } from "react";
import c from "./VissGroup.module.css";

export function VissGroup({
  viss,
  minItemWidth,
  maxItemWidth,
}: {
  viss: ReactElement[];
  minItemWidth: string;
  maxItemWidth: string;
}): ReactElement {
  return (
    <div
      className={c.group}
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(${minItemWidth}, ${maxItemWidth}))`,
      }}
    >
      {viss.map((v, i) => (
        <div key={i}>{v}</div>
      ))}
    </div>
  );
}
